import {
  Component,
  Input,
  EventEmitter,
  Output,
  ContentChild,
  ViewEncapsulation
} from '@angular/core';
import { MdlChipContactDirective } from './mdl-chip-contact.directive';



export class MdlChipComponent {

   public mdlLabel;
   public mdlActionIcon;
   public actionClick = new EventEmitter();
   public chipContact: MdlChipContactDirective;

  public action() {
    this.actionClick.emit();
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'mdl-chip',
  host: {
    '[class.mdl-chip]': 'true',
    '[class.mdl-chip--contact]': 'chipContact'
  },
  template: `
    <ng-content></ng-content>
    <span *ngIf="mdlLabel" class="mdl-chip__text">{{mdlLabel}}</span>
    <button *ngIf="mdlActionIcon" (click)="action()" type="button" class="mdl-chip__action">
      <mdl-icon>{{mdlActionIcon}}</mdl-icon>
    </button>
  `,
  encapsulation: ViewEncapsulation.None
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'mdlLabel': [{ type: Input, args: ['mdl-label', ] },],
'mdlActionIcon': [{ type: Input, args: ['mdl-action-icon', ] },],
'actionClick': [{ type: Output, args: ['action-click', ] },],
'chipContact': [{ type: ContentChild, args: [MdlChipContactDirective, ] },],
};
}



interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
